import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveCompanyBranch, GetCompanyBranch } from './index';

// Api's
import { companyApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getCompanyBranchSaga(action: GetCompanyBranch) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      companyApi.getDomain,
      action.payload.request
    );
    if (response.data.result) {
      yield put(saveCompanyBranch(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveCompanyBranch(null, true, resultError.messagesDataError));
    }
  }
}
